var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._v("\n  Please try\n  "), _c('a', {
    staticClass: "empty-link-style",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.reloadPage
    }
  }, [_vm._v("refreshing this page")]), _vm._v("\n  or contact "), _c('a', {
    staticClass: "empty-link-style",
    attrs: {
      "href": "/contact_us"
    }
  }, [_vm._v("support")]), _vm._v(".\n")]);

}
var staticRenderFns = []

export { render, staticRenderFns }